export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVDokladCR';
export const NAME = 'DokladCiselnaRada';

export enum DOKLAD_CIS_RADA_TYP{ Normalni = 0, Slucena = 1, Dilci = 2 }
export const DOCUMENT_NO_MAXLENGTH = 10;
export const DOKLADCR_ID_KEY = 'DOKLADCR_ID';
